import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import TopBar from "../components/TopBar";
import { Layout } from "./Layout";
import { RouteLoadingFallback } from "../components/RouteLoadingFallback";

export function UnauthLayout() {
  return (
    <Layout topBarComponent={<TopBar />}>
      <Suspense fallback={<RouteLoadingFallback />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
}
